$(document).on('click', '[data-toggle-price-info]', () => {
  $('[data-price-info-action]').toggleClass('hide');
  $('[data-price-info-details]').toggleClass('hide');
});
